import { render, staticRenderFns } from "./livePriceUphold-import.vue?vue&type=template&id=c9b8b4f2&scoped=true&"
import script from "./livePriceUphold-import.vue?vue&type=script&lang=js&"
export * from "./livePriceUphold-import.vue?vue&type=script&lang=js&"
import style0 from "./livePriceUphold-import.vue?vue&type=style&index=0&id=c9b8b4f2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b8b4f2",
  null
  
)

export default component.exports